import React from 'react';
import { motion } from 'framer-motion';

const PossibilitySection = () => {
    return (
        <section className="w-full py-[50px] md:py-[100px] bg-[#F1F1F1] font-sora">
            <div className="max-w-[1400px] mx-auto px-[20px] lg:px-[80px] flex flex-col md:flex-row items-center gap-[32px] md:gap-[40px] lg:gap-[80px]">

                <motion.div
                    initial={{ opacity: 0, y: 30, x: 0 }}
                    whileInView={{ opacity: 1, y: 0, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    variants={{
                        md: { initial: { opacity: 0, x: -40, y: 0 }, whileInView: { opacity: 1, x: 0, y: 0 } }
                    }}
                    className="w-full md:w-1/2 flex justify-center order-1"
                >
                    <div className="w-full max-w-[500px] md:max-w-none overflow-hidden shadow-xl">
                        <motion.img
                            whileHover={{ scale: 1.05 }}
                            transition={{ duration: 0.7 }}
                            src="/assets/products/img1.png"
                            alt="Glowing abstract sphere representing infinite possibilities"
                            className="w-full h-auto object-cover"
                        />
                    </div>
                </motion.div>

                <motion.div
                    initial={{ opacity: 0, y: 30, x: 0 }}
                    whileInView={{ opacity: 1, y: 0, x: 0 }}
                    viewport={{ once: true, amount: 0.2 }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.1 }}
                    className="w-full md:w-1/2 flex flex-col justify-center items-center md:items-start text-center md:text-left order-2"
                >
                    <h2 className="text-[20px] lg:text-[30px] font-[600] font-sora text-[#01386A] tracking-tight mb-[16px] md:mb-[20px] leading-[1.2] max-w-[450px]">
                        Here, anything is possible
                    </h2>

                    <p className="text-[#49577A] font-graphik text-[14px] md:text-[16px] font-[500] font-graphik leading-[1.6] md:leading-[1.7] max-w-[450px] md:max-w-[429px]">
                        Grow with a team that supports you, learn by doing real work, and build skills that matter, while creating meaningful impact for clients and communities with Mobikode.
                    </p>
                </motion.div>

            </div>
        </section>
    );
};

export default PossibilitySection;